class ErrorHandler {
	handle (error) {
		console.error(error)
	}
}

module.exports = new ErrorHandler()
